import * as echarts from 'echarts'
import {
    colorRgb,
    selfAdaptionPX
} from './commonFun.js'
import { NumberUtils } from 'great-jsutils'
import china from "../../../public/china.json";
const hexToRgba = (hex, opacity) => {
    let rgbaColor = "";
    let reg = /^#[\da-f]{6}$/i;
    if (reg.test(hex)) {
        rgbaColor = `rgba(${parseInt("0x" + hex.slice(1, 3))},${parseInt("0x" + hex.slice(3, 5))},${parseInt("0x" + hex.slice(5, 7))},${opacity})`;
    }
    return rgbaColor;
};

export const BarLineCharts = function (dom, opt, maxData, self = false, clickFunction = {}) {
    var { legend, grid, dataZoom, xAxis, yAxis, tooltip, series, changeRate } = { ...opt }
    var fix = opt?.decimal ?? 2
    if (series[0].type == 'line') {
        Object.assign(series[0], {
            // areaStyle: {
            //   normal: {
            //     color: new echarts.graphic.LinearGradient(
            //       0,
            //       0,
            //       0,
            //       1,
            //       [{
            //         offset: 0,
            //         color: hexToRgba(series[0].color, 0.5)
            //       },
            //       {
            //         offset: 1,
            //         color: hexToRgba(series[0].color, 0)
            //       }
            //       ],
            //       false
            //     ),
            //     // shadowColor: hexToRgba(series[0].color, 0.1),
            //     shadowBlur: 10
            //   }
            // },
        })
    }
    else if (series[0].type == 'bar') {
        series.push(
            {
                type: "bar",
                barWidth: '35%',
                barGap: "-138%",
                yAxisIndex: 2,
                data: maxData,
                itemStyle: {
                    normal: {
                        color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [
                            {
                                offset: 0,
                                // color: hexToRgba(series[0].color, 0.3), // 0% 处的颜色
                                color: 'rgba(32,99,111,0.5)', // 0% 处的颜色

                            },
                            {
                                offset: 1,
                                // color: hexToRgba(series[0].color, 0.3), // 100% 处的颜色
                                color: 'rgba(32,99,111, 0.5)', // 0% 处的颜色
                            },
                        ],
                            false
                        ),
                    },
                },
            },
        )

    }

    var option = {
        legend: opt?.mylegend ?? {
            itemWidth: selfAdaptionPX(0.16),
            itemHeight: selfAdaptionPX(0.10),
            textStyle: {
                fontSize: selfAdaptionPX(0.12),
                color: "#333",
                padding: [3, 0, 3, 0],
            },
            orient: "horizontal",
            width: '90%',
            type: 'scroll',
            pageFormatter: '',
            pageButtonItemGap: -6,
            pageIconColor: '#1978E5',
            pageIconSize: 10, //翻页按钮大小
            pageIconInactiveColor: '#aaa',
            top: 5,
            right: legend?.right ?? 'center',
            data: legend?.data ?? [],
            show:false
        },
        tooltip: opt.mytooltip ?? {
            trigger: tooltip ? tooltip.tooltip : "axis",
            axisPointer: {
                // 坐标轴指示器，坐标轴触发有效
                type: tooltip ? tooltip.type : "shadow", // 默认为直线，可选为：'line' | 'shadow'
            },
            // formatter(params) {
            //     var relVal = params[0].name;
            //     console.log('tooltip数据值',params)
            //     for (var i = 0, l = params.length; i < l; i++) {
            //         if ((params[i].value??'') !== ''&&params[i].value.indexOf('.')>-1) {
            //             params[i].value = Number(params[i].value).toFixed(2)
            //         }
            //        //遍历出来的值一般是字符串，需要转换成数字，再进项tiFixed四舍五入
            //         relVal += '<br/>' + params[i].marker + params[i].seriesName + ' : ' + '<strong>'+ (params[i].value??'-') +'</strong>' 
            //     }
            //     return relVal;
            // },
        },

        grid: opt?.mygrid ?? {
            top: grid?.top ?? "60",
            left: grid?.left ?? "3%",
            right: grid?.right ?? "3%",
            bottom: grid?.bottom ?? "10",
            containLabel: true,
        },
        dataZoom: opt?.mydataZoom ?? [
            {
                type: "slider",
                show: false,
                backgroundColor: "#f2fbfb",
                // bottom:40,
                height: "5%", //高度
                bottom: "4%", //距离底部的高度
                // fillerColor: "#dff6e9",
                fillerColor: "#f2fbfb",

                handleStyle: {
                    borderWidth: 0,
                    color: "#8ccaad",
                },
                filterMode: "filter",
                zoomOnMouseWheel: true,
                // start: - 15,
                // endValue: - 1,
                start: 0,
                end: 100,
                // startValue: data.entire == "1" ? undefined : xAxis.length - 15,
                // endValue: data.entire == "1" ? undefined : xAxis.length - 1,
            },

            {
                type: "inside",
                zoomOnMouseWheel: true,
                show: true,
            },
        ],
        xAxis: opt?.myxAxis ?? [
            {
                show: true,
                type: "category",
                //boundaryGap: false,
                axisTick: {
                    show: false,
                    alignWithLabel: true, //true 的时候有效，可以保证刻度线和标签对齐
                },
                // X轴线的颜色
                axisLine: {
                    lineStyle: {
                        // color: "#ccc",
                        color: '#A3D9A7'
                    },
                },
                // X轴字体颜色
                axisLabel: {
                    textStyle: {
                        fontSize: selfAdaptionPX(0.14),
                        color: '#333',
                    },
                    interval: "auto",
                },

                data: xAxis?.data ?? [],
            },
        ],

        yAxis: opt?.myyAxis ?? [
            {
                show: xAxis?.data?.length ?? false,
                type: "value",
                // 控制y轴数据不在0开始，根据实际情况设置初始值
                // scale: true,//最小数据贴地处理为添加最大和最小值
                name: yAxis?.leftName ?? "",
                min: (value) => {
                    let num = (value.min)-1
                    if (num>0) {
                        num = num - (num/20)
                    }
                    return Math.floor(num);
                },
                max: (value) => {
                    let num = (value.max)+1
                    if (num>0) {
                        num = num + (num/20)
                    }
                    return Math.floor(num);
                },
                // 设置Y轴名称的对齐方式  align: right/left/align,
                nameTextStyle: {
                    align: "right",
                    color: '#333',
                    fontSize: selfAdaptionPX(0.14),
                    padding: yAxis?.namePadding ?? [0, -3, -5, 0]
                },
                // minInterval:1,
                splitNumber: yAxis?.splitNumber ?? null,
                // position: {
                //   left: "0",
                // },
                // 设置保留小数位数
                // axisLabel: {
                //   formatter: function (value, index) {
                //     return value.toFixed(2);
                //   },
                // },
                splitLine: {
                    show: true,
                    lineStyle: {
                        color: "#A3D9A7",
                        type: "dashed",
                    },
                },
                axisLabel: {//y轴文字的配置
                    textStyle: {
                        color: "#333",//Y轴内容文字颜色
                        fontSize: selfAdaptionPX(0.14)
                    },
                    // interval: "",
                    splitNumber: 3,
                },
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: "#A3D9A7",
                        width: 1,
                        // type: "dotted",
                    },
                },
                axisTick: {
                    show: false,
                },

            },
            {
                type: "value",
                name: yAxis?.rightName ?? "",
                show: xAxis?.data?.length && (yAxis?.show ?? false),
                nameTextStyle: {
                    align: "left",
                },
                axisLabel: {
                    formatter: "{value} " + yAxis?.foramtRight ?? "{value} %",
                },
                axisTick: {
                    show: false,
                },
                axisLine: {
                    show: false,
                },
                scale: true,
                splitLine: {
                    show: false,
                    lineStyle: {
                        type: "dotted",
                        color: "#A3D9A7",
                        width: 1,
                    },
                },
            }, {
                //为添加背景额外加的Y轴
                type: "",
                name: "",
                max: 1,
                show: false,
                axisLine: {
                    show: false, //隐藏y轴
                },
                axisLabel: {
                    show: false, //隐藏刻度值
                },
            },
        ],
        animation: true,
        series
    }

    dom.setOption(option, true)
    var timer = null
    function debounce(fn, delay = 1500) {
        return (function (...args) {
            if (timer) {
                clearTimeout(timer)
            }
            timer = setTimeout(() => {
                // fn.call(this, args)
                fn()
            }, delay)
        })()
    }

    window.addEventListener('resize', () => {
        // setTimeout(() => { dom.resize() }, 1000)
        debounce(() => {
            dom.resize()
        }, 1500)

    })

    if (self) {
        dom.getZr().on('click', function (params) {
            let op = dom.getOption()
            let pointInPixel = [params.offsetX, params.offsetY]
            if (dom.containPixel('grid', pointInPixel)) {
                const xIndex = dom.convertFromPixel({ seriesIndex: 0 }, pointInPixel)[0]
                // let handleIndex = Number(xIndex)
                // var name = op.yAxis[0].data[handleIndex]  // 当前点击的 Y轴 的名称
                //获得图表中点击的列
                var xYear = op.xAxis[0].data[xIndex]   // 当前点击的 X轴 的名称
                // console.log(xYear,op,"op");

            }


        });
    }

}
